module.exports = __webpack_public_path__ + "static/media/discographie.d3859622.JPG";